import * as types from '../mutation-types'

// initial state
const state = {
  sportMiniBet: {
    toggle: false,
    allow: true,
    windowEvent: null,
    betAmount: 0,
    rightside: false,
  }
}

// getters
const getters = {
  sportMiniBet: state => state.sportMiniBet,
}

// actions
const actions = {
}

// mutations
const mutations = {
  [types.SPORT_MINIBET] (state, payload ) {
    state.sportMiniBet = payload
  },

  [types.SPORT_MINIBET_TOGGLE] (state, payload ) {
    state.sportMiniBet.toggle = payload
  },

  [types.SPORT_MINIBET_WINDOWEVENT] (state, payload ) {
    state.sportMiniBet.windowEvent = payload
  },

  [types.SPORT_MINIBET_BETAMOUNT] (state, payload ) {
    state.sportMiniBet.betAmount = payload ? payload : 0
  },

  [types.SPORT_MINIBET_RIGHTSIDE] (state, payload ) {
    state.sportMiniBet.rightside = payload
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./resources/wob/vue/store/modules/sport-minibet.js